// extracted by mini-css-extract-plugin
export var enTitle = "ContentsList-module--enTitle--cd9a7";
export var heading = "ContentsList-module--heading--afb1d";
export var inner = "ContentsList-module--inner--48d19";
export var item = "ContentsList-module--item--c4514";
export var link = "ContentsList-module--link--d40e4";
export var linkWrap = "ContentsList-module--linkWrap--fad79";
export var list = "ContentsList-module--list--b8ede";
export var summary = "ContentsList-module--summary--26e22";
export var title = "ContentsList-module--title--b5ebb";